//src/pages/TonicKnowledgeAuthorContentList.jsx
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faPlus } from '@fortawesome/free-solid-svg-icons';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
import MainLayout from '../../layouts/MainLayout';
import logo from '../../assets/logo.svg';

const TonicKnowledgeAuthorContentList = () => {
  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;
  const location = useLocation();
  const [tonicKnowledges, setTonicKnowledges] = useState([]);
  const [fetchData, { loading }] = useFetch();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [name, setName] = useState('');
  const [place, setPlace] = useState('');
  const [tags, setTags] = useState('');
  const [purpose, setPurpose] = useState('');
  const [purposeHead, setPurposeHead] = useState('');
  const purposeInitialized = useRef(false);
  const [selectedTonicKnowledgeId, setSelectedTonicKnowledgeId] = useState(null);

  useEffect(() => {
    document.title = authState.isLoggedIn ? `${authState.user.name}'s dashboard` : "Think5Whys";
  }, [authState]);

  const fetchTonicKnowledges = useCallback(() => {
    const  config = {
        url: "/tonicknowledge/mytonicknowledges",
        method: "post",
        headers: { Authorization: authState.token },
        data: { userId: authState.user._id }
    };
    // console.log("My TonicKnowledge Search Payload: ", config);
  
    fetchData(config, { showSuccessToast: false }).then(data => setTonicKnowledges(data.tonicKnowledges));
  }, [authState.token, fetchData, authState.user._id]);
  
  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchTonicKnowledges();
  }, [authState.isLoggedIn, fetchTonicKnowledges]);

  const [isDeleteClicked, setIsDeleteClicked] = useState(false);
  
  const deleteClicked = () => {
    setIsDeleteClicked(true);
  }
  
  const noDeleteClicked = () => {
    setIsDeleteClicked(false);
  }

  const handleDelete = (id) => {
    const config = {
      url: `/tonicknowledge/${id}`,
      method: "delete",
      headers: { Authorization: authState.token }
    };
    fetchData(config).then(() => fetchTonicKnowledges());
  }

  const handleView = (tonicKnowledgeId) => {
    setSelectedTonicKnowledgeId(prevId => (prevId === tonicKnowledgeId ? null : tonicKnowledgeId));
  };

  const handleCloseTonicKnowledgeDetails = () => {
    setSelectedTonicKnowledgeId(null);
  };

  const handleFromDateChange = (date) => {
    setFromDate(date);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };

  const handleSearch = () => {
    // Implement search functionality
  };

  const handleTonicKnowledgeClick = (tonicKnowledgeId) => {
    setSelectedTonicKnowledgeId(tonicKnowledgeId);
  };

  const handleTonicKnowledgeShare = (tonicKnowledgeId) => {
    setSelectedTonicKnowledgeId(tonicKnowledgeId);
  };

  const handleTonicKnowledgeSave = (tonicKnowledgeId) => {
    setSelectedTonicKnowledgeId(tonicKnowledgeId);
  };

  const handleTonicKnowledgePrint = (tonicKnowledgeId) => {
    setSelectedTonicKnowledgeId(tonicKnowledgeId);
  };

  const formatDateTime = (date) => {
    const options = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

const formatDate = (date) => {
  const options = {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false
  };
  const jsDate = new Date(date);
  const day = jsDate.getDate().toString().padStart(2, '0');
  const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
  const year = jsDate.getFullYear();
  return `${day}-${month}-${year}`;
};

  const sortedTonicKnowledges = [...tonicKnowledges].sort((a, b) => new Date(b.date) - new Date(a.date));

  return (
    <>
      <MainLayout>
        <div className='mt-12'>
          <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>My Tonic Knowledge Creations</h2>
        </div>
        <div className="my-2 mx-auto py-4">
            {/* Search bar */}
            {/* <div className="search-container">
              <div className="search-row">
                <div className="date-picker-container">
                  <DatePicker selected={fromDate} onChange={setFromDate} />
                  <FontAwesomeIcon icon={faCalendarAlt} style={{ color: 'white' }} />
                </div>
                <span style={{ color: 'white' }}>to</span>
                <div className="date-picker-container">
                  <DatePicker selected={toDate} onChange={setToDate} />
                  <FontAwesomeIcon icon={faCalendarAlt} style={{ color: 'white' }} />
                </div>
              </div>
              <div className="search-row">
                <input type="text" placeholder="Tags" value={tags} onChange={(e) => setTags(e.target.value)} style={{ width: '75%', fontSize: '16px' }} />
                <button className="small-button" onClick={handleSearch}>Search</button>
              </div>
            </div> */}
            <div className="border border-gray-300 p-4 mt-4">
              <div className="mt-2">
                <div className="mt-2">
                  {tonicKnowledges && tonicKnowledges.length !== 0 && (
                    <div className="flex justify-between items-center border-b border-b-gray-300">
                      <div>
                      <h3 className='text-m mt-1 mx-1 text-yellow-200'>{tonicKnowledges.length} Records Found!</h3>
                      </div>
                      <div className='mr-4'>
                      <Link to='/authordesk-tonicknowledge/add' className='block w-full h-full px-1 py-2 ml-4 bg-blue-500'>
                        <FontAwesomeIcon className="bg-blue-500 mr-4" icon={faPlus} />  Add New
                      </Link>
                    </div>
                  </div>
                  )}
                </div>
              </div>
              {loading ? (
                <Loader />
              ) : (
                <div>
                  {tonicKnowledges && tonicKnowledges.length === 0 ? (
                    <div className='h-[300px] flex items-center justify-center gap-4 text-yellow-300'>
                      <div className="flex justify-between items-center">
                      <div>
                      <h3 className='text-lg mt-1 mx-2 text-orange-400'>No Record Found!</h3>
                      </div>
                      <div>
                      <Link to='/tonicKnowledges/add' className='block w-full h-full px-1 py-2 ml-4 bg-blue-500'>
                        <FontAwesomeIcon className="bg-blue-500 mr-4" icon={faPlus} />  Add New
                      </Link>
                    </div>
                  </div>
                    </div>
                  ) : (
                    sortedTonicKnowledges.map((tonicKnowledge, index) => (
                      <div key={tonicKnowledge._id} className='bg-white my-1 p-1 text-gray-600 rounded-md shadow-md text-sm'>
                        <div className='flex'>
                          <span className='font-medium'>{index + 1}{'. '}{formatDate(tonicKnowledge.date)}{', ('}{tonicKnowledge.tonicName}{' Tonic), '}{tonicKnowledge.headline}</span>
                          <Tooltip text={"View details"} position={"top"}>
                            <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleView(tonicKnowledge._id)}>
                              <i className="fa-solid fa-eye"></i>
                            </span>
                          </Tooltip>
                          <Tooltip text={"Edit this record"} position={"top"}>
                            <Link to={`/authordesk-tonicknowledge/${tonicKnowledge._id}`} className='mr-4 text-green-600 cursor-pointer'>
                              <i className="fa-solid fa-pen"></i>
                            </Link>
                          </Tooltip>
                          <Tooltip text={"Delete this record"} position={"top"}>
                          {/* <span className='text-red-500 cursor-pointer mr-2' onClick={() => deleteClicked()}> */}

                          <span className='text-red-300 cursor-pointer mr-2'>
                            <i className="fa-solid fa-trash"></i>
                          </span>
                          </Tooltip>
                          { isDeleteClicked && (
                            <div>
                              <div
                                className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center"
                                style={{ zIndex: 1000 }}
                              >
                                <div className="w-6/12 flex flex-row justify-center bg-blue-200 text-black border-b border-b-gray-300 mr-4 ml-4 p-4">
                                    <button
                                      className="bg-red-700 w-40"
                                      onClick={() =>  handleDelete(tonicKnowledge._id) }
                                      style={{ maxWidth: "150px" }}
                                    >
                                      Confirm To Delete
                                    </button>
                                    <button
                                      className="bg-yellow-300 ml-4 text-black w-40"
                                      onClick={() =>  noDeleteClicked() }
                                      style={{ maxWidth: "150px" }}
                                    >
                                      No I Do Not Want To Delete
                                    </button>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                        {/* <div className='whitespace-pre  text-blue-700'>{tonicKnowledge.title}</div> */}
                        {selectedTonicKnowledgeId === tonicKnowledge._id && (
                          <div className='bg-gray-200 text-black'>
                            <p className='bg-blue-700 text-white justify-center text-m mt-2 mb-2'>
                              <h2 className='text-white'><strong>Tonic Knowledge Details</strong></h2>
                            </p>
                            <p><strong>Tonic:</strong> {tonicKnowledge.tonicName}</p>
                            <p><strong>Author:</strong> {tonicKnowledge.authorName}</p>

                            <p><strong>Date:</strong> {formatDate(tonicKnowledge.date)}</p>
                            <p><strong>Headline:</strong> {tonicKnowledge.headline}</p>
                            <p><strong>Description:</strong></p>
                            <p
                              className="text-black"
                              dangerouslySetInnerHTML={{ __html: tonicKnowledge.brief }}
                            ></p>
                            <p><strong>Language:</strong> {tonicKnowledge.language}</p>
                            <p><strong>Tags:</strong> {tonicKnowledge.searchTags}</p>
                            <p><strong>Source:</strong> {tonicKnowledge.infoSource}</p>

                            <p><strong>Is Active:</strong> {tonicKnowledge.isActive ? "Yes":"No"}</p>
                            
                            <p><strong>Date Created:</strong> {formatDateTime(tonicKnowledge.createdDate)}</p>
                          </div>
                        )}
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>
          </div>
      </MainLayout>
    </>
  )
}

export default TonicKnowledgeAuthorContentList